<template>
  <div id="pageTable">
    <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
    <v-container grid-list-xl fluid>
      <v-card class="pa-2">
        <v-layout row wrap>
          <v-flex lg8 md8 sm12 pa-2>
            <v-form ref="form" v-model="valid">
              <v-layout row wrap>
                <v-flex v-bind:class="currentItem.OrderType > 0 ? 'lg3 md3 sm12' : 'lg4 md4 sm12'">
                  <v-select label="Trạng thái" v-model="currentItem.Status" :items="quote_status_list" item-text="name"
                    item-value="value" disabled></v-select>
                </v-flex>
                <v-flex  v-bind:class="currentItem.OrderType > 0 ? 'lg3 md3 sm12' : 'lg4 md4 sm12'">
                  <v-select label="Line hàng" v-model="currentItem.LineType" :items="quote_line_list" item-text="name"
                    item-value="value"></v-select>
                </v-flex>
                <v-flex  v-bind:class="currentItem.OrderType > 0 ? 'lg3 md3 sm12' : 'lg4 md4 sm12'">
                  <v-select label="Cách chia đơn" v-model="currentItem.OrderType" :items="quote_type_list" item-text="name"
                    item-value="value"></v-select>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.OrderType > 0">
                  <v-select :disabled="currentItem.OrderType != 2" label="NV mua hàng" v-model="currentItem.BuyerID"
                    :items="purchaseList" item-text="Username" item-value="ID"></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg4 md4 sm12>
                  <v-autocomplete label="Khách hàng" v-model="currentItem.UID" :items="customers"
                    :item-text="getCustomerText" item-value="ID" @change="onSelectedCustomer" clearable></v-autocomplete>
                </v-flex>
                <v-flex lg4 md4 sm12>
                  <v-text-field :disabled="currentItem.UID > 0" v-model="currentItem.FullName" label="Tên khách"
                    class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg4 md4 sm12>
                  <v-text-field :disabled="currentItem.UID > 0" v-model="currentItem.PhoneNumber" label="Số điện thoại" class="input-group--focused"
                    :rules="phoneRules" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg4 md4 sm12>
                  <v-select label="Loại hàng" v-model="currentItem.ProductType" :items="list_product_types" item-text="Name"
                    item-value="ID" item-disabled="IsHidden" :rules="require_validation"></v-select>
                </v-flex>
                <v-flex lg4 md4 sm12>
                  <v-select label="Kho gửi" v-model="currentItem.ChinaStoreID" :items="china_stores" item-text="Name"
                    item-value="ID"></v-select>
                </v-flex>
                <v-flex lg4 md4 sm12>
                  <v-select label="Kho nhận" v-model="currentItem.ReceivePlaceID" :items="vn_stores" item-text="Name"
                    item-value="ID"></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg12 md12 sm12>
                  <v-text-field v-model="currentItem.ProductName" label="Tên sản phẩm"
                    class="input-group--focused"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg3 md3 sm12>
                  <v-text-field v-model="currentItem.Qty" label="Số lượng" type="number" step="1"
                    class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-text-field v-model="currentItem.Color" label="Màu sắc" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-text-field v-model="currentItem.Size" label="Kích cỡ" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg3 md3 sm12>
                  <v-text-field v-model="currentItem.Material" label="Chất liệu"
                    class="input-group--focused"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg12 md12 sm12>
                  <v-text-field v-model="currentItem.Note" label="Ghi chú" class="input-group--focused"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-flex lg4 md4 sm12 pa-2>
            <v-widget title="Tin nhắn">
              <div slot="widget-content">
                  <message-box :orderId="Number(modifyId)" :disabled="!currentItem.ID" :orderType="9" :internalOnly="true"></message-box>
              </div>
            </v-widget>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <div v-if="medias" class="ml-4">
            <a v-for="img in medias" :key="img.ID" :href="img.FileUrl" target="_blank">
              <img :src="img.FileUrl" style="height: 56px; width: 56px; margin: 2px;">
            </a>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="gotoCustomerMedia(currentItem.ID, currentItem.GUID)" class="ma-2" v-if="currentItem.Status > 0">
            <v-icon color="red darken-3">fa-upload</v-icon> HÌNH ẢNH KHÁCH GỬI
          </v-btn>
        </v-layout>
      </v-card>
      <v-card class="pa-2 mt-3">
        <v-card-title>
          <span class="title">Danh sách báo giá</span>
          <v-spacer></v-spacer>
          <v-btn @click="appendQuoteDetail" class="ma-2" v-if="currentItem.Status < 4 && currentItem.Status > 0">
            <v-icon color="red darken-3">fa-plus</v-icon> THÊM NCC BÁO GIÁ
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex lg12 md12 sm12 pa-0>
              <v-data-table :headers="headers" :items="items" :server-items-length="total_rows" 
                :mobile-breakpoint="100" disable-pagination hide-default-footer>
                <template v-slot:item="{ item, index }">
                  <tr v-bind:style="{'color': !item.OrderID && currentItem.Status == 4 ? 'gray' : ''}">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.CreatedBy }}</td>
                    <td>{{ item.SupplierContact }}</td>
                    <td><a :href="item.SupplierLink" target="_blank">{{ item.SupplierLink }}</a></td>
                    <td class="text-end">{{ item.ExchangeRate | currency }}</td>
                    <td class="text-end">{{item.Price | currency('', 2)}} </td>
                    <td class="text-end">{{ item.FeeShip | currency('', 2) }}</td>
                    <td class="text-end">{{ item.FeeBuy | currency('', 1) }}</td>
                    <td class="text-end">{{ item.Qty | currency }}</td>
                    <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                    <td class="text-end">{{ item.WeightOfPack | currency('', 2) }}</td>
                    <td class="text-end">{{ item.LengthOfPack | currency }}</td>
                    <td class="text-end">{{ item.WidthOfPack | currency }}</td>
                    <td class="text-end">{{ item.HeightOfPack | currency }}</td>
                    <td class="text-end">{{ item.CostOfProduct | currency }}</td>
                    <td class="text-end">{{ item.TotalAmount | currency }}</td>
                    <td>{{ item.CreatedDate | display_date('DD/MM/YYYY') }}</td>
                    <td v-if="item.OrderID"><a :href="'/don-hang/chi-tiet/' + item.OrderID" target="_blank">MD{{
                        item.OrderID }}</a></td>
                    <td v-else></td>
                    <td class="truncate"><v-tooltip top max-width="250" color="light-blue lighten-2 black--text">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">{{ item.Note }}</span>
                        </template>
                        <span>{{ item.Note }}</span>
                    </v-tooltip></td>
                    <td class="text-center" v-if="currentItem.Status > 0">
                      <v-tooltip top v-if="!item.OrderID && currentItem.Status < 4">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="createOrder(item)">
                            <v-icon color="green darken-2">fa-shopping-cart</v-icon>
                          </v-btn>
                        </template>
                        <span>Tạo đơn hàng</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="printDetailItem(item)">
                            <v-icon color="blue darken-2">fa-print</v-icon>
                          </v-btn>
                        </template>
                        <span>In báo giá</span>
                      </v-tooltip>
                      <v-tooltip>
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="gotoDetailMedia(item.ID, item.GUID)">
                            <v-icon medium>fa-photo</v-icon>
                          </v-btn>
                        </template>
                        <span>Hình ảnh</span>
                      </v-tooltip>
                      <v-tooltip top v-if="!item.OrderID && currentItem.Status < 4">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="gotoDetailItem(item.ID)">
                            <v-icon medium>fa-edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Sửa báo giá</span>
                      </v-tooltip>
                      <v-tooltip top v-if="!item.OrderID && currentItem.Status < 4">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on" @click="deleteDetailItem(index)">
                            <v-icon color="red" medium>fa-trash-alt</v-icon>
                          </v-btn>
                        </template>
                        <span>Xoá báo giá</span>
                      </v-tooltip>
                    </td>
                    <td v-else></td>
                  </tr>
                </template>
                <template slot="no-data">
                  <span>
                    <p class="pt-2">Không có dữ liệu</p>
                  </span>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogQuote" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="title">Báo giá</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap pa-3 v-if="currentDetailItem">
            <v-flex lg12 md12 sm12>
              <v-text-field label="Nhà cung cấp" v-model="currentDetailItem.SupplierContact"></v-text-field>
            </v-flex>
            <v-flex lg12 md12 sm12>
              <v-text-field label="Link NCC" v-model="currentDetailItem.SupplierLink"></v-text-field>
            </v-flex>
            <v-flex lg6 md6 sm12 v-if="adminRole" pr-1>
              <h-currency-input v-model="currentDetailItem.FeeBuy" :decimal="1" label="Phí mua hộ (%)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12 v-if="adminRole">
              <h-currency-input v-model="currentDetailItem.ExchangeRate" :decimal="0" label="Tỷ giá"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12 pr-1>
              <h-currency-input v-model="currentDetailItem.WeightPrice" :decimal="0" label="Giá cân (đ)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12>
              <h-currency-input v-model="currentDetailItem.VolumePrice" :decimal="0" label="Giá khối (đ)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12 pr-1>
              <h-currency-input v-model="currentDetailItem.Price" :decimal="2" label="Đơn giá (¥)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12>
              <h-currency-input v-model="currentDetailItem.FeeShip" :decimal="2" label="Cước nội địa (¥)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12  pr-1>
              <h-currency-input v-model="currentDetailItem.Qty" :decimal="0" label="Số lượng/thùng (pcs)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg6 md6 sm12>
              <h-currency-input v-model="currentDetailItem.WeightOfPack" :decimal="2" label="Cân nặng thùng (kg)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg4 md4 sm12 pr-1>
              <h-currency-input v-model="currentDetailItem.LengthOfPack" :decimal="0" label="Chiều dài thùng (cm)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg4 md4 sm12 pr-1>
              <h-currency-input v-model="currentDetailItem.WidthOfPack" :decimal="0" label="Chiều rộng thùng (cm)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg4 md4 sm12>
              <h-currency-input v-model="currentDetailItem.HeightOfPack" :decimal="0" label="Chiều cao thùng (cm)"
                class="input-group--focused"></h-currency-input>
            </v-flex>
            <v-flex lg12 md12 sm12>
              <v-text-field label="Ghi chú" v-model="currentDetailItem.Note"></v-text-field>
            </v-flex>
            <v-layout row wrap ma-0>
              <div v-if="currentDetailItem.Medias" class="ml-4">
                <a v-for="img in currentDetailItem.Medias" :key="img.ID" :href="img.FileUrl" target="_blank">
                  <img :src="img.FileUrl" style="height: 56px; width: 56px; margin: 2px;">
                </a>
              </div>
              <v-spacer></v-spacer>
              <v-btn @click="gotoDetailMedia(currentDetailItem.ID, currentDetailItem.GUID)">
                <v-icon color="red darken-3">fa-upload</v-icon> HÌNH ẢNH
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogQuote = false">Hủy</v-btn>
          <v-btn color="blue darken-1" text @click="onCreateQuoteDetail">Đồng ý</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-media :MaxFile="max_file" :ObjectType="object_type" :ObjectID="selectedObjectID" :GUID="selectedGUID" :dialogUpload="dialogMedia"
      :title="media_title" @closePopup="closeUploadMedia"></upload-media>
    <v-dialog v-model="dialogNewOrder" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">{{ !currentItem.UID ? 'Tạo mới khách hàng' :  'Tạo mới đơn hàng'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap v-if="!currentItem.UID">
              <!-- <v-flex lg12 md12 sm12><p class="body-2 font-weight-bold text-red">Tạo khách hàng mới</p></v-flex>
              <v-flex lg12 md12 sm12>
                <v-text-field label="Tên đăng nhập" v-model="newCustomer.Username"></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <v-text-field label="Mật khẩu" v-model="newCustomer.Password"></v-text-field>
              </v-flex> -->
              <CustomerDetail :isPopup="true" @saveCustomer="savedCustomer"></CustomerDetail>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12>
                        <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <img style="max-width: 56px; max-height: 56px" v-if="!hideImage"
                          v-bind:src="`${getImages(index)}`" ref="imageFile" />
                      </v-flex>
                      <v-flex lg4 md4 sm12>
                        <v-text-field label="Tên sản phẩm" v-model="item.Name"></v-text-field>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <h-currency-input label="Đơn giá (¥)" :decimal="2" v-model="item.Price"></h-currency-input>
                      </v-flex>
                      <v-flex lg2 md2 sm12>
                        <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                      </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                      <div class="row">
                        <div class="col-md-4">
                          <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image"
                            ref="imageFile" />
                          <img style="max-width: 56px; max-height: 56px" v-else src="/static/spinner.gif" />
                        </div>
                        <div class="col-md-8">
                          <button @click="chooseImage()" style="cursor: point">Tải ảnh</button>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field label="Tên sản phẩm" v-model="newProduct.Name"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="2" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNewOrder = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";
import configs from "@/configs";
import { mapState } from "vuex";
import { print_quote } from "@/commons/hpod"
import media from "@/components/popups/media";
import CustomerDetail from "@/views/Customer/CustomerDetail";
import { sendErrorNotice, sendSuccessNotice, makeid, removeDiacritics } from "@/commons/utils";
import firebase from 'firebase';
export default {
  components: {
    "upload-media": media,
    VWidget,
    MessageBox,
    CustomerDetail
  },
  data() {
    return {
      phoneRules: [
        v => (!!v && v != undefined) || 'Hãy nhập số điện thoại',
        v => /^\d+$/.test(v) || 'Số điện thoại chỉ bao gồm các số 0-9',
        v => v && v.length === 10 || 'Số điện thoại có độ dài 10 chữ số'
      ],
      require_validation: [(v) => !!v || "Trường dữ liệu không được để trống."],
      quote_status_list: configs.QUOTE_STATUS,
      quote_type_list: configs.QUOTE_TYPE,
      quote_line_list: configs.QUOTE_LINE,
      selectedQuoteDetailID: 0,
      dialogQuote: false,
      dialogDetailMedia: false,
      dialogMedia: false,
      imageData: null,
      hideImage: false,
      valid: false,
      headers: [
        {
          text: "STT",
          value: "",
          filterable: false,
          sortable: false
        },
        {
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Nhà cung cấp",
          value: "SupplierContact",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Link NCC",
          value: "SupplierLink",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tỷ giá",
          value: "ExchangeRate",
          align: 'end',   
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Giá (¥)",
          value: "Price",
          align: 'end',   
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cước nội địa (¥)",
          value: "FeeShip",
          align: 'end',
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Phí mua hộ (%)",
          value: "FeeBuy",
          align: 'end',
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "SL/thùng",
          value: "Qty",
          align: 'end',
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số thùng",
          value: "NumberOfPack",
          align: 'end',
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cân nặng (thùng)",
          value: "WeightOfPack",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều dài (thùng)",
          value: "LengthOfPack",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều rộng (thùng)",
          value: "WidthOfPack",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều cao (thùng)",
          value: "HeightOfPack",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Giá full",
          value: "CostOfProduct",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thành tiền",
          value: "TotalAmount",
          align: 'end',
          filterable: true,
          decimal: 0,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Đơn hàng",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          width: 220,
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      newOrder: {
        UID: 0,
        Products: []
      },
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      },
      newCustomer: {
        Username: '',
        Password: '123456'
      },
      dialogNewOrder: false,
      max_file: 0,
      object_type: '',
      selectedObjectID: 0,
      selectedGUID: null,
      media_title: '',
    };
  },
  computed: {
    modifyId() {
      return this.$route.params.Pid;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    purchaseRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
    },
    isLeader() {
      return this.$store.state.authentication.user.isleader;
    },
    csRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
    },
    ...mapState({
      loading: (state) => state.quotes.loading,
      currentItem: (state) => state.quotes.selected,
      currentDetailItem: (state) => state.quote_detail.selected,
      customers: state => state.customer.master.data,
      staffs: (state) => state.commons.all_users,
      p_staffs: (state) => _.filter(state.commons.all_users, function (o) { return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase); }),
      vn_stores: state => state.commons.stores,
      china_stores: state => state.commons.chinaStores,
      prices: (state) => _.filter(state.prices.all.data, function (o) { return ((state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || o.Global == 1; }),
      product_types: (state) => state.productType.all.data,
      configuration: state => state.configuration.selected
    }),
    purchaseList() {
      if (this.isLeader && this.purchaseRole) {
        return _.filter(this.p_staffs, (item) => { return item.LeaderID == this.$store.state.authentication.user.userid; });
      }
      return this.p_staffs;
    },
    items() {
      return this.currentItem.Details;
    },
    medias() {
      return this.currentItem.Medias;
    },
    total_rows() {
      return this.currentItem && this.currentItem.Details ? this.currentItem.Details.length : 0;
    },
    list_product_types() {
      return this.product_types ? _.filter(this.product_types, (p) => { return !p.IsHidden }) : [];
    }
  },
  watch: {
    modifyId() {
      this.refreshData();
    },
  },
  methods: {
    refreshData() {
      this.$store.commit("orderComment/setOrderCommentList", {data: []});
      this.$store.dispatch("productType/getList");
      this.getCustomerList();
      if (this.modifyId > 0) {
        this.$store.dispatch("quotes/getDetail", this.modifyId);
      } else if(!this.currentItem.GUID) {
        this.$store.commit("quotes/setDetail", {
          data: {
            ID: 0,
            GUID: makeid(80),
            Status: 1,
            LineType: 0,
            OrderType: 0,
            PhoneNumber: '',
            Details: []
          },
        });
      }
    },
    saveData() {
      if (!this.$refs.form.validate()) {
        sendErrorNotice("Hãy kiểm tra lại dữ liệu đã nhập!");
        return;
      }
      if(this.currentItem.Status == 0) {
        sendErrorNotice("Báo giá đã huỷ!");
        return;
      }
      let customer = _.find(this.customers, { 'ID': this.currentItem.UID });
      let payload = {
        ...this.currentItem,
        UID: this.currentItem.UID || 0,
        PriceID: this.currentItem.PriceID || 0
      };
      if(customer) {
        payload.Username = customer.Username;
        payload.FullName = `${customer.FirstName} ${customer.LastName}`;
        payload.PhoneNumber = customer.PhoneNumber;
      }
      if (this.currentItem.ID) {
        delete payload.Details;
        payload.ModifiedBy = this.$store.state.authentication.user.username;
      }
      else {
        payload.CreatedBy = this.$store.state.authentication.user.username;
      }
      if (this.purchaseRole && !this.csRole && !this.currentItem.ID) {
        payload.BuyerID = this.$store.state.authentication.user.userid;
        payload.OrderType = 2;
      }
      if (this.csRole && !this.currentItem.ID) {
        payload.CustomerServiceID = this.$store.state.authentication.user.userid;
      }
      this.$store.dispatch("quotes/setDetail", {
        data: payload,
        id: this.currentItem.ID,
      }).then(p => {
        if(!this.currentItem.ID) {
          this.$router.push({
            name: "QuoteDetail",
            params: {
              Pid: p.ID,
              title: `Chi tiết báo giá (#${p.ID})`,
            },
          });
        }
      });
    },
    onCreateQuoteDetail() {
      if(this.configuration && this.configuration.ExchangeRateIn > this.currentDetailItem.ExchangeRate) {
        sendErrorNotice("Tỷ giá không được thấp hơn tỷ giá gốc!");
        return;
      }
      if (this.purchaseRole && !this.csRole) {
        this.currentDetailItem.BuyerID = this.$store.state.authentication.user.userid;
      }
      if (this.currentItem.ID) {
        this.$store.dispatch("quote_detail/setDetail", {
          data: {
            ...this.currentDetailItem,
            QuoteID: this.currentItem.ID,
            ModifiedBy: this.$store.state.authentication.user.username
          },
          id: this.currentDetailItem.ID
        });
      }
      else {
        if (!this.currentItem.Details) {
          this.currentItem.Details = [];
        }
        this.currentItem.Details.push({
          ...this.currentDetailItem,
          QuoteID: 0,
          CreatedBy: this.$store.state.authentication.user.username
        });
        sendSuccessNotice("Đã thêm mới báo giá!");
      }
      this.dialogQuote = false;
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
        is_master: 1,
        fields: ["ID", "Username", "PhoneNumber", "FirstName", "LastName", "ReceivePlaceID", "ChinaStoreID"]
      });
    },
    appendQuoteDetail() {
      this.$store.commit("quote_detail/setDetail",{data: {
        ID: 0,
        Medias: [],
        GUID: makeid(80),
        QuoteID: this.currentItem.ID
      }});
      setTimeout(() => { this.dialogQuote = true }, 100);
    },
    onEditWeight(id) {
      this.$store.dispatch("quote_detail/getDetail", id).then((ret) => { this.dialogQuote = true });
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    onSelectedCustomer() {
      let cus = _.find(this.customers, { ID: this.currentItem.UID });
      if (cus) {
        this.currentItem.PhoneNumber = cus.PhoneNumber;
        this.currentItem.FullName = `${cus.FirstName} ${cus.LastName}`;
        this.currentItem.ReceivePlaceID = cus.ReceivePlaceID;
        this.currentItem.ChinaStoreID = cus.ChinaStoreID;
      }
    },
    deleteDetailItem(index) {
      let removed = this.currentItem.Details.splice(index, 1);
      if (removed && removed.length > 0) {
        this.$store.dispatch("quote_detail/removeDetail", removed[0].ID);
      }
    },
    gotoDetailItem(id) {
      this.$store.dispatch("quote_detail/getDetail", id).then(p => {
        this.dialogQuote = true;
      });
    },
    gotoDetailMedia(id, guid) {
      this.selectedObjectID = id;
      this.selectedGUID = guid;
      this.max_file = 5;
      this.object_type = 'quote';
      this.dialogMedia = true;
      this.media_title = 'Hình ảnh báo giá';
    },
    gotoCustomerMedia(id, guid) {
      this.selectedObjectID = id;
      this.selectedGUID = guid;
      this.max_file = 5;
      this.object_type = 'quote_customer';
      this.dialogMedia = true;
      this.media_title = 'Hình ảnh yêu cầu của khách hàng';
    },
    printDetailItem(item) {
      this.$store.dispatch("quotes/recalcDetail", item.ID).then(p => {
        let detailQuote = _.find(this.currentItem.Details, { 'ID': item.ID });
        print_quote(this.currentItem, detailQuote);
      });
    },
    createOrder(item) {
      if(!this.currentItem.UID) {
        this.$store.commit("customer/setCustomerDetail",{data: { 'Username': this.generateUsername(this.currentItem.FullName, this.currentItem.PhoneNumber), 'FirstName': this.currentItem.FullName, 'PhoneNumber': this.currentItem.PhoneNumber }});
      }
      this.$store.commit("quote_detail/setDetail", {data: item});
      this.newOrder = {
        UID: this.currentItem.UID,
        Products: []
      };
      this.newOrder.Products.push({ 
        Link: item.SupplierLink,
        Image: item.Medias && item.Medias.length > 0 ? item.Medias[0].FileUrl : this.currentItem.Medias && this.currentItem.Medias.length > 0 ? this.currentItem.Medias[0].FileUrl : '',
        Name: this.currentItem.ProductName,
        Price: item.Price,
        Quantity: this.currentItem.Qty
      });
      this.dialogNewOrder = true;
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Name: '',
        Price: 0,
        Quantity: 1
      }
    },
    generateUsername(fullName, phoneNumber) {
      // Chuyển họ tên về dạng viết thường và loại bỏ các dấu
      const processedName = removeDiacritics(fullName.toLowerCase().replace(/\s+/g, ''));

      // Lấy 3 chữ số cuối của số điện thoại
      const lastThreeDigits = phoneNumber.slice(-3);

      // Kết hợp họ tên và 3 chữ số cuối để tạo tên đăng nhập
      const username = processedName + lastThreeDigits;

      return username;
    },
    savedCustomer(p) {
      this.$store.dispatch("quotes/setDetail", {
        data: {
          UID: p.ID,
          Username: p.Username
        },
        id: this.currentItem.ID,
      });
    },
    createNewOrder() {
      if(!this.currentItem.UID) {
        this.$root.$emit('REQUEST_SAVE_CUSTOMER');
        return;
      }
      if (this.newOrder.Products.length == 0) {
        sendErrorNotice("Hãy nhập danh sách sản phẩm!");
        return;
      }
      if(this.csRole) {
        this.newOrder.CustomerServiceID = this.$store.state.authentication.user.userid;
      }
      
      if(this.currentItem.UID > 0) {
        let cus = _.find(this.customers, { ID: this.currentItem.UID });
        this.newOrder.UID = this.currentItem.UID;
        this.newOrder.Username = this.currentItem.Username;
        if(!this.csRole) {
          this.newOrder.CustomerServiceID = this.currentItem.CustomerServiceID;
        }
      }
      else {
        let cus = _.find(this.customers, { Username: this.newCustomer.Username });
        if(cus) {
          sendErrorNotice("Tên đăng nhập đã tồn tại!");
          return;
        }
        this.newOrder.Password = this.newCustomer.Password;
        this.newOrder.FirstName = this.currentItem.FullName;
        this.newOrder.Username = this.newCustomer.Username;
        this.newOrder.PhoneNumber = this.newCustomer.PhoneNumber;
      }
      this.newOrder.ChinaStoreID = this.currentItem.ChinaStoreID;
      this.newOrder.ReceivePlaceID = this.currentItem.ReceivePlaceID;
      this.newOrder.ProductType = this.currentItem.ProductType;
      this.newOrder.BuyerID = this.currentDetailItem.BuyerID || 0;
      this.newOrder.CustomerServiceID = this.currentItem.CustomerServiceID;
      this.newOrder.ExchangeRate = this.currentDetailItem.ExchangeRate;
      this.newOrder.FeeShipCN = this.currentDetailItem.FeeShip;
      
      this.$store.dispatch("main_order/createNew", { 'data': this.newOrder }).then(p => {
        this.currentItem.Status = 4;
        this.currentDetailItem.OrderID = p.data.ID;
        this.$store.dispatch("quote_detail/setDetail", {
          data: {
            OrderID: p.data.ID,
            QuoteID: this.currentItem.ID
          },
          id: this.currentDetailItem.ID,
        });
        let quote_payload = {
          Status: 4 // đã chốt
        }
        if(!this.currentItem.UID) {
          quote_payload.UID = p.data.UID;
          quote_payload.Username = p.data.Username;
        }
        this.$store.dispatch("quotes/setDetail", {
          data: quote_payload,
          id: this.currentItem.ID,
        });
        this.dialogNewOrder = false;
        sendSuccessNotice('Tạo mới đơn hàng thành công.');
      });
    },
    markQuote() {
      if(this.currentItem.Status == 0) {
        sendErrorNotice("Báo giá đã huỷ!");
        return;
      }
      this.$store.dispatch("quotes/setDetail", {
        data: {Status: 3},
        id: this.currentItem.ID,
      });
    },
    chooseImage() {
      this.newProduct.Image = '';
      this.$refs.fileInput.click();
    },
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.$refs.fileInput.value = null;
      this.onUpload()
    },
    onUpload() {
      const arrFileType = this.imageData.name.split('.');
      const storageRef = firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
      storageRef.on(`state_changed`, snapshot => {
        this.newProduct.Image = '/static/spinner.gif';
      },
        error => {
          sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
        },
        () => {
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.newProduct.Image = url;
            this.hideImage = true;
            this.$nextTick(() => this.hideImage = false);
          });
        }
      );
    },
    getImages(index) {
      return this.newOrder.Products[index].Image;
    },
    closeUploadMedia() {
      this.dialogMedia = false;
      console.log("Close Upload");
      let param = {filter: []}
      if(this.object_type == 'quote') {
        if (this.object_type) {
          param.filter.push({
            column: "ObjectType",
            value: this.object_type,
            condition: "s_equal",
          });
        }
        if (this.selectedGUID) {
          param.filter.push({
            column: "GUID",
            value: this.selectedGUID,
            condition: "s_equal",
          });
        }
        else if (this.selectedObjectID) {
          param.filter.push({
            column: "ObjectID",
            value: this.selectedObjectID,
            condition: "equal",
          });
        }
        this.$store.dispatch("media/getList", param).then(p => {
          this.currentDetailItem.Medias = p.data;
        });
      }
    },
    cancelQuote() {
      if(this.currentItem.Status == 0) {
        sendErrorNotice("Báo giá đã huỷ!");
        return;
      }
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'CancelQuote', this.currentItem.ID, `Bạn có chắc chắn huỷ báo giá không?`);
    }
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch("configuration/getDetail", 1);
    this.$store.dispatch("productType/getList");
    this.$store.dispatch("prices/getList");
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$store.dispatch("commons/getAllUsers");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_OTHER_ACTION", this.markQuote);
    this.$root.$on("REQUEST_CREATE_DATA", this.cancelQuote);
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'CancelQuote') {
        this.$store.dispatch("quotes/setDetail", {
          'data': {Status: 0},
          'id': id,
        });
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("REQUEST_OTHER_ACTION");
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("CONFIRMED_ACTION");
  },
};
</script>
<style lang="stylus" scoped>
.image-product {
  width: 64px;
  height: 64px;
}
.p-line {
  margin: 2px;
}
.p-line-inc {
  font-size: 10px;
}
</style>